"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const consts_1 = __importDefault(require("./consts"));
const api_1 = __importDefault(require("../../api"));
const UserStore_1 = require("./lightState/UserStore");
class SameAuth {
}
exports.default = SameAuth;
SameAuth.isAuthen = () => {
    let userinfo = localStorage.getItem(consts_1.default.USER_INFO_STORAGE_KEY);
    if (userinfo === null) {
        return false;
    }
    else {
        return JSON.parse(userinfo);
    }
};
SameAuth.authenUrlCallback = (doCheck, onSuccess) => __awaiter(void 0, void 0, void 0, function* () {
    var url = new URL(window.location.href);
    var authStr = url.searchParams.get("token") || url.searchParams.get("auth");
    if (authStr !== null) {
        localStorage.setItem(consts_1.default.TOKEN_KEY, authStr);
        try {
            var user = yield new api_1.default().get_current_user();
            var storeValue = Object.assign({ token: authStr }, user);
            if (user) {
                UserStore_1.loginSuccessed(storeValue);
                onSuccess(user);
            }
            window.history.pushState(null, "", "/");
        }
        catch (res) {
            console.log("err", res);
            if (res.status === 403 || res.status === 401) {
                localStorage.removeItem(consts_1.default.USER_INFO_STORAGE_KEY);
                localStorage.removeItem(consts_1.default.TOKEN_KEY);
                window.history.pushState(null, "", "/");
            }
            window.history.pushState(null, "", "/");
        }
    }
});
//# sourceMappingURL=SameAuth.js.map